import styled from "@emotion/styled";
import { Button as F7Button } from "framework7-react";

import { ActivityFragment } from "@/generated/graphql/graphql";
import { ButtonProps } from "@/types/framework7-react";

const Button = styled(F7Button)`
  color: var(--f7-theme-color-text-color);

  &.color-bad,
  &.color-bad:active,
  &.color-bad:focus {
    background-color: var(--app-color-bad) !important;
    border-color: var(--app-color-bad) !important;
  }

  &.color-education,
  &.color-education:active,
  &.color-education:focus {
    background-color: var(--app-color-education) !important;
    border-color: var(--app-color-education) !important;
  }

  &.color-family,
  &.color-family:active,
  &.color-family:focus {
    background-color: var(--app-color-family) !important;
    border-color: var(--app-color-family) !important;
  }

  &.color-good,
  &.color-good:active,
  &.color-good:focus {
    background-color: var(--app-color-good) !important;
    border-color: var(--app-color-good) !important;
  }

  &.color-life,
  &.color-life:active,
  &.color-life:focus {
    background-color: var(--app-color-life) !important;
    border-color: var(--app-color-life) !important;
  }

  &.color-other,
  &.color-other:active,
  &.color-other:focus {
    background-color: var(--app-color-other) !important;
    border-color: var(--app-color-other) !important;
  }

  &.color-primary,
  &.color-primary:active,
  &.color-primary:focus {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
  }

  &.color-private,
  &.color-private:active,
  &.color-private:focus {
    background-color: var(--app-color-private) !important;
    border-color: var(--app-color-private) !important;
  }

  &.color-sleep,
  &.color-sleep:active,
  &.color-sleep:focus {
    background-color: var(--app-color-sleep) !important;
    border-color: var(--app-color-sleep) !important;
  }

  &.color-unset,
  &.color-unset:active,
  &.color-unset:focus {
    background-color: var(--app-color-unset) !important;
    border-color: var(--app-color-unset) !important;
  }

  &.color-work,
  &.color-work:active,
  &.color-work:focus {
    background-color: var(--app-color-work) !important;
    border-color: var(--app-color-work) !important;
  }
`;

type ActivityLauncherButtonProps = {
  activity: ActivityFragment;
} & Pick<ButtonProps, "onClick" | "disabled">;

export function ActivityLauncherButton({ activity, onClick, disabled }: ActivityLauncherButtonProps) {
  const nameLength = activity.name?.length ?? 0;
  const dynamicFontSize = nameLength > 8 ? "0.8rem" : nameLength > 4 ? "1rem" : "1.2em";

  return (
    <Button
      fill
      large
      preloader
      color={activity.categoryKey}
      disabled={disabled}
      style={{ fontSize: dynamicFontSize, height: "100%", whiteSpace: "wrap", width: "100%" }}
      onClick={onClick}
    >
      {activity.name}
    </Button>
  );
}
